import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryManageRedirectRoute: InvariantJiraRoute = {
	name: 'projects-directory-manage-redirect',
	path: '/secure/project/ViewProjects.jspa',
};
